<template lang="pug">
  div
    .uppy-component(:class='uppyId')
    div(:class="'uppybar uppybar-' + uppyId" v-if='this.uppyProps.statusBar')
</template>

<script>
  import server from '@/server'
  import Uppy from 'uppy/lib/core/Core'
  import Dashboard from 'uppy/lib/plugins/Dashboard'
  import AwsS3 from 'uppy/lib/plugins/AwsS3'
  import FileInput from 'uppy/lib/plugins/FileInput'
  import StatusBar from 'uppy/lib/plugins/StatusBar'
  import 'uppy/dist/uppy.css'

  export default {
    name: 'uppy',
    props: {
      uppyId: { type: String, default: null },
      uppySize: { type: Number, default: 3000000 },
      uppyProps: {
        type: Object,
        default: () => {
          return {
            dashboard: true,
            s3: true,
            input: false,
            statusBar: false
          }
        }
      },
      fileTypes: { type: Array, default: () => ['image/jpg', 'image/jpeg', 'image/png'] }
    },
    mounted () {
      let uppy = new Uppy(
        {
          autoProceed: true,
          restrictions: {
            maxFileSize: this.uppySize,
            maxNumberOfFiles: 5,
            allowedFileTypes: false
          }
        }
      )

      const usePlugins = () => {
        if (this.uppyProps.dashboard) {
          uppy.use(Dashboard, {
            inline: true,
            target: '.' + this.uppyId,
            note: 'Max 5 files, up to 3 MB'
          })
        }

        if (this.uppyProps.s3) {
          uppy.use(AwsS3, { getUploadParameters: this.serverCall })
        }

        if (this.uppyProps.input) {
          uppy.use(FileInput, {
            target: '.' + this.uppyId
          })
        }
        if (this.uppyProps.statusBar) {
          uppy.use(StatusBar, {
            target: '.uppybar-' + this.uppyId
          })
        }
      }

      usePlugins()
      uppy.run()

      uppy.on('core:complete', (files) => {
        this.$emit('on-success', files)
      })
    },
    methods: {
      serverCall (file) {
        return server.post('/presigned-puts',
          {
            filename: file.id + '.' + file.extension,
            content_type: file.type
          })
          .then((response) => {
            return {
              method: response.data.method,
              url: response.data.url,
              fields: {}
            }
          })
          .catch((err) => {
            console.log(err)
          })
      }
    }
  }
</script>

<style lang='sass'>
  .uppy-component
    .UppyDashboard-inner
      width: 100%
      height: auto
    .uppy-FileInput-btn
      color: white
      border-color: #36a9e1
      background-color: #36a9e1

    .uppy-FileInput-btn:hover
      background-color: #1e8fc6
      border-color: #1e8fc6

  .uppybar
    position: relative
    width: 70%
    left: 50%
    transform: translateX(-50%)
</style>



// WEBPACK FOOTER //
// src/components/Shared/Uppy.vue